"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var add_business_svg_1 = __importDefault(require("../../../assets/icons/vendas/add_business.svg"));
var add_card_svg_1 = __importDefault(require("../../../assets/icons/vendas/add_card.svg"));
var add_shopping_cart_svg_1 = __importDefault(require("../../../assets/icons/vendas/add_shopping_cart.svg"));
var barcode_svg_1 = __importDefault(require("../../../assets/icons/vendas/barcode.svg"));
var barcode_reader_svg_1 = __importDefault(require("../../../assets/icons/vendas/barcode_reader.svg"));
var barcode_scanner_svg_1 = __importDefault(require("../../../assets/icons/vendas/barcode_scanner.svg"));
var collections_bookmark_svg_1 = __importDefault(require("../../../assets/icons/vendas/collections_bookmark.svg"));
var credit_card_svg_1 = __importDefault(require("../../../assets/icons/vendas/credit_card.svg"));
var credit_card_gear_svg_1 = __importDefault(require("../../../assets/icons/vendas/credit_card_gear.svg"));
var credit_card_heart_svg_1 = __importDefault(require("../../../assets/icons/vendas/credit_card_heart.svg"));
var credit_card_off_svg_1 = __importDefault(require("../../../assets/icons/vendas/credit_card_off.svg"));
var credit_score_svg_1 = __importDefault(require("../../../assets/icons/vendas/credit_score.svg"));
var factory_svg_1 = __importDefault(require("../../../assets/icons/vendas/factory.svg"));
var input_circle_svg_1 = __importDefault(require("../../../assets/icons/vendas/input_circle.svg"));
var local_shipping_svg_1 = __importDefault(require("../../../assets/icons/vendas/local_shipping.svg"));
var monetization_on_svg_1 = __importDefault(require("../../../assets/icons/vendas/monetization_on.svg"));
var package_2_svg_1 = __importDefault(require("../../../assets/icons/vendas/package_2.svg"));
var payments_svg_1 = __importDefault(require("../../../assets/icons/vendas/payments.svg"));
var person_chat_svg_1 = __importDefault(require("../../../assets/icons/vendas/person_chat.svg"));
var point_of_sale_svg_1 = __importDefault(require("../../../assets/icons/vendas/point_of_sale.svg"));
var production_quantity_limits_svg_1 = __importDefault(require("../../../assets/icons/vendas/production_quantity_limits.svg"));
var qr_code_svg_1 = __importDefault(require("../../../assets/icons/vendas/qr_code.svg"));
var qr_code_scanner_svg_1 = __importDefault(require("../../../assets/icons/vendas/qr_code_scanner.svg"));
var receipt_svg_1 = __importDefault(require("../../../assets/icons/vendas/receipt.svg"));
var remove_shopping_cart_svg_1 = __importDefault(require("../../../assets/icons/vendas/remove_shopping_cart.svg"));
var sell_svg_1 = __importDefault(require("../../../assets/icons/vendas/sell.svg"));
var shopping_bag_svg_1 = __importDefault(require("../../../assets/icons/vendas/shopping_bag.svg"));
var shopping_basket_svg_1 = __importDefault(require("../../../assets/icons/vendas/shopping_basket.svg"));
var shopping_cart_svg_1 = __importDefault(require("../../../assets/icons/vendas/shopping_cart.svg"));
var shopping_cart_checkout_svg_1 = __importDefault(require("../../../assets/icons/vendas/shopping_cart_checkout.svg"));
var shopping_cart_off_svg_1 = __importDefault(require("../../../assets/icons/vendas/shopping_cart_off.svg"));
var storefront_svg_1 = __importDefault(require("../../../assets/icons/vendas/storefront.svg"));
var warehouse_svg_1 = __importDefault(require("../../../assets/icons/vendas/warehouse.svg"));
var universal_currency_svg_1 = __importDefault(require("../../../assets/icons/vendas/universal_currency.svg"));
var currency_exchange_svg_1 = __importDefault(require("../../../assets/icons/vendas/currency_exchange.svg"));
var receipt_long_svg_1 = __importDefault(require("../../../assets/icons/vendas/receipt_long.svg"));
var request_quote_svg_1 = __importDefault(require("../../../assets/icons/vendas/request_quote.svg"));
var shopping_mode_svg_1 = __importDefault(require("../../../assets/icons/vendas/shopping_mode.svg"));
var Vendas = {
    "shopping_mode": shopping_mode_svg_1.default,
    "add_business": add_business_svg_1.default,
    "add_card": add_card_svg_1.default,
    "add_shopping_cart": add_shopping_cart_svg_1.default,
    "barcode": barcode_svg_1.default,
    "barcode_reader": barcode_reader_svg_1.default,
    "barcode_scanner": barcode_scanner_svg_1.default,
    "collections_bookmark": collections_bookmark_svg_1.default,
    "credit_card": credit_card_svg_1.default,
    "credit_card_gear": credit_card_gear_svg_1.default,
    "credit_card_heart": credit_card_heart_svg_1.default,
    "credit_card_off": credit_card_off_svg_1.default,
    "credit_score": credit_score_svg_1.default,
    "factory": factory_svg_1.default,
    "input_circle": input_circle_svg_1.default,
    "local_shipping": local_shipping_svg_1.default,
    "monetization_on": monetization_on_svg_1.default,
    "package_2": package_2_svg_1.default,
    "payments": payments_svg_1.default,
    "person_chat": person_chat_svg_1.default,
    "point_of_sale": point_of_sale_svg_1.default,
    "production_quantity_limits": production_quantity_limits_svg_1.default,
    "qr_code": qr_code_svg_1.default,
    "qr_code_scanner": qr_code_scanner_svg_1.default,
    "receipt": receipt_svg_1.default,
    "receipt_long": receipt_long_svg_1.default,
    "remove_shopping_cart": remove_shopping_cart_svg_1.default,
    "request_quote": request_quote_svg_1.default,
    "sell": sell_svg_1.default,
    "shopping_bag": shopping_bag_svg_1.default,
    "shopping_basket": shopping_basket_svg_1.default,
    "shopping_cart": shopping_cart_svg_1.default,
    "shopping_cart_checkout": shopping_cart_checkout_svg_1.default,
    "shopping_cart_off": shopping_cart_off_svg_1.default,
    "storefront": storefront_svg_1.default,
    "warehouse": warehouse_svg_1.default,
    "universal_currency": universal_currency_svg_1.default,
    "currency_exchange": currency_exchange_svg_1.default,
};
exports.default = Vendas;
